import { styled } from "goober";
import { ClickButton } from "./ClickButton";
import { PressButton } from "./PressButton";

const footerActionStyle = `
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: none;
  padding: 4px 6px;
  margin: -4px -2px;
  border-radius: 4px;
  cursor: pointer;
  color: inherit;

  &:hover {
    background: var(--alpha4);
  }

  &:active {
    background: var(--alpha8);
  }
`;

export const FooterAction = styled(PressButton)`
  ${footerActionStyle}
`;

export const FooterClickAction = styled(ClickButton)`
  ${footerActionStyle}
`;
